// extracted by mini-css-extract-plugin
module.exports = {"openinapp":"aRe_2","show-sticky":"Z0CKu"};